module.exports = "/assets/images/dynamic-temperature-bg.mp4";